export enum IntroAnimationVariant {
  DETECTOR_HIGHLIGHTS = 'detector_highlights',
  DETECTOR_REPORT = 'detector_report',
  PARAPHRASE_OUTPUT = 'paraphrase_output',
  PARAPHRASE_TONE = 'paraphrase_tone',
}
